import { mapParamsBySchema } from '../../../util';
import { apiRequest } from '../../../Services/Common/ApiRequest';
import Global from '../../../Services/Common/Global';
import { WOS_BASIC_03_Schema } from './M_WOS_BASIC_03_Schema';
import useSearchMutaion from '../../../Hooks/apis/useSearchMutaion';

const toDataResponse = (res) =>
  res != null && Array.isArray(res) ? { data: res } : res;

const toDataResponseFromResult = (res) => {
  const list = res?.Data ?? res?.data ?? (Array.isArray(res) ? res : []);
  return { data: Array.isArray(list) ? list : [] };
};

/** 작업중지 상세 조회 GetWosBasicR2 (SP_WOS_BASIC_R2) */
export const useSearch1 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const params = mapParamsBySchema(
      WOS_BASIC_03_Schema.mapper.search1,
      context
    );
    const res = await apiRequest(
      'post',
      Global.urls.WorkStop.getWosBasicR2,
      params
    );
    return toDataResponseFromResult(res);
  }, successOptions);
};

/** 작업중지 여부 조회 GetWosBasic03R1 (SP_WOS_BASIC_R3) */
export const useSearch2 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const params = mapParamsBySchema(
      WOS_BASIC_03_Schema.mapper.search2,
      context
    );
    const res = await apiRequest(
      'post',
      Global.urls.WorkStop.getWosBasic03R1,
      params
    );
    return toDataResponseFromResult(res);
  }, successOptions);
};
